import { render } from "./ArtistFilter.vue?vue&type=template&id=4282d85c&scoped=true"
import script from "./ArtistFilter.vue?vue&type=script&lang=js"
export * from "./ArtistFilter.vue?vue&type=script&lang=js"

import "./ArtistFilter.vue?vue&type=style&index=0&id=4282d85c&scoped=true&lang=css"

import exportComponent from "/Users/huangyuhao/Desktop/art-sleuth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4282d85c"]])

export default __exports__